import Router from 'vue-router'
import addresses from './addresses'
import app from './app'
import campaigns from './campaigns'
import companies from './companies'
import jobs from './jobs'
import persons from './persons'
import products from './products'
import users from './users'
import archiv from './archive'
import agencies from './agencies'
import settings from './settings'
import error from './error'
import store from '@/store'

const router = new Router({

    linkActiveClass: 'active',
    mode: 'history',
    routes: [
        {
            path: '/',
            redirect: '/products',
        },
        ...addresses,
        ...app,
        ...campaigns,
        ...companies,
        ...jobs,
        ...persons,
        ...products,
        ...users,
        ...archiv,
        ...agencies,
        ...settings,
        ...error
    ]

})

router.afterEach((to) => {
    const matched = to.matched.slice().reverse().find(r => r.meta && r.meta.title)
    const baseTitle = matched ? `ZMÜK | ${matched.meta.title}` : 'ZMÜK'

    // Bei Produktdetailseiten den Produktnamen + aktiven Reiter ergänzen
    const isProductView = to.matched.some(r => r.name === 'products/view')
    if (isProductView && to.params.id) {
        const product = store.getters['products/byId'](Number(to.params.id))
        if (product && product.name) {
            const childMatch = to.matched.slice().reverse().find(r => r.meta && r.meta.title && r.name !== 'products/view')
            document.title = childMatch
                ? `ZMÜK | ${product.name} | ${childMatch.meta.title}`
                : `ZMÜK | ${product.name}`
            return
        }
    }

    document.title = baseTitle
})

export default router
